


















import {defineComponent} from '@vue/composition-api';

export default defineComponent({
  name: 'UOttawaTask1Fr',
  inheritAttrs: false,
});
